import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import Translation from '../../Translation/cont/Translation';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import ChooseWeekButtons from '../../general/ChooseWeekButtons';
import { FLYER, NEWSPAPER } from '../../../constants/printType';
import ChooseStartEndDateContainer from '../cont/ChooseStartEndDateContainer';

const ChooseWeek = ({
    features,
    activeWeek, 
    weeks, 
    cinemaId,
    printType, 
    printID, 
    printPk,
    landscape,
    closePagePath,
    flyerServerData,
    printToolSetWeek,
}) => {
    if(!features) {
        return ''
    }

    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })
    const path = `${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${printPk}/${currentPrintFormat.landscape}`

    let pageTitle = null 

    if(printType === FLYER && flyerServerData.flyers && flyerServerData.flyers[printPk] && flyerServerData.flyers[printPk].flyerSettings.name) {
        pageTitle = flyerServerData.flyers[printPk].flyerSettings.name
    }

    return (
        <WrapperPageSimple
            pageTitleTransId={printConfig.routes[printType].transIdname} 
            pageTitle={pageTitle} 
            closePagePath={closePagePath}
        >
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                <div>
                    <h3 className="gap-20 title-list text-regular"><Translation id="print_flyer_select_week">Spielwoche auswählen</Translation></h3>

                    <ChooseWeekButtons
                        activeWeek={parseInt(activeWeek)}
                        weeks={weeks} 
                        path={path}
                        pathAfterWeek={'showcasePreviewMovie' === printType ? 'all' : 'all/edit'}
                        updateWeek={printToolSetWeek}
                        activeWeekIsLink={true}
                    />

                    <h3 className="title-list text-regular"><Translation id="print_flyer_custom_date_period_title">Eigener Zeitraum</Translation></h3>
                    <h4 className="gap-20 text-regular"><Translation id="print_flyer_select_start_end_date">Start- und Enddatum auswählen</Translation></h4>
                    <ChooseStartEndDateContainer
                        printPk={printPk}
                        printType={printType}
                        path={'showcasePreviewMovie' === printType ? `${path}/custom/all` : `${path}/custom/all/edit`}
                        flyerServerData={flyerServerData}
                    />
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default ChooseWeek